import axios, { AxiosInstance } from 'axios';
import { getTokenHeaderFromMsal } from '../helper/config';
import { msalInstance } from '../main';
import { createStore } from 'jotai';
import { globalAtom, globalState } from '../store/atom';
import { clearAllBrowserData } from '../utils/storage';

const store = createStore();
const axiosApiInstance: AxiosInstance = axios.create({
  baseURL: import.meta.env.VITE_API_DEV,
});

axiosApiInstance.interceptors.request.use(
  async (config: any) => {
    try {
      const token = await getTokenHeaderFromMsal();
      config.headers['Authorization'] = `Bearer ${token}`;
      return config;
    } catch (error) {
      console.error('Failed to get token:', error);
      return Promise.reject(error);
    }
  },
  (error) => Promise.reject(error)
);

// catch 401 response and log him out
axiosApiInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      const instance = msalInstance;
      store.set(globalAtom, () => globalState);
      instance.logoutRedirect();
      return Promise.reject(error);
    } else if (
      error.response?.status === 403 ||
      error.response?.status === 404
    ) {
      clearAllBrowserData();
      // refresh the page
      window.location.reload();
      return Promise.reject(error);
    } else {
      return Promise.reject(error);
    }
  }
);

export default axiosApiInstance;
